import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ComponentRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

export abstract class AtxModalComponent implements OnInit {
    @Input('title') protected title;
    @Input('options') protected options;

    @ViewChild('container', { read: ViewContainerRef })
    protected container: ViewContainerRef;
    protected componentRef: ComponentRef<{}>;

    constructor(private _activeModal: NgbActiveModal) {}

    ngOnInit() {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }

    protected acceptModal() {
        this._activeModal.close();
    }

    protected closeModal() {
        this._activeModal.dismiss();
    }

    protected dismissModal() {
        this._activeModal.dismiss();
    }
}
